import { Dispatch, SetStateAction } from 'react';
import { Button } from 'react-bootstrap';

import Icon from 'components/icons/Icon';
import { IconSymbol } from 'components/icons/Icon.types';

type ShowPasswordButtonProps = {
  showPassword: boolean;
  setShowPassword: Dispatch<SetStateAction<boolean>>;
};

export function ShowPasswordButton(props: ShowPasswordButtonProps) {
  const { showPassword, setShowPassword } = props;
  return (
    <Button
      variant="outline-secondary"
      size="sm"
      className="right"
      onClick={() => setShowPassword((prev) => !prev)}
      tabIndex={-1}
      aria-label={showPassword ? 'Hide password' : 'Show password'}
      style={{ marginLeft: '0.5em' }}
    >
      {showPassword ? (
        <Icon symbol={IconSymbol.hidden} size={24} inline />
      ) : (
        <Icon symbol={IconSymbol.visible} size={24} inline />
      )}
    </Button>
  );
}
